import { FC } from 'react'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import Icon from '@/root/ui/shared/Icon'

export const CloseIcon: FC<IconProps> = ({ width = 20, height = 20, ...rest }) => (
  <Icon type="Cross" width={width} height={height} alt="CloseIcon" data-testid="close-icon" {...rest} />
)
